import { OdcType } from "./OdcType";
import { CountryHandlingTime } from "./CountryHandlingTime";
import { SupplierHandlingTime } from "./SupplierHandlingTime";
import { SprHandlingTime } from "./SprHandlingTime";

export default interface Odc {
  Id: number;
  Gsdb: string;
  Name: string;
  Type: OdcType;
  Details?: string;

  // Address
  Street?: string;
  City?: string;
  Zipcode?: string;

  // Country
  CountryId: number;

  // Region / Area
  Region?: string;
  ZipArea?: string;

  // GeoCoordinates
  Latitude?: string;
  Longitude?: string;
  MgLatitude?: number;
  MgLongitude?: number;

  // Handling times
  DefaultInboundHandlingTime: string;
  ReturnHandlingTime: string;
  CountryHandlingTimes: CountryHandlingTime[];
  SupplierHandlingTimes: SupplierHandlingTime[];
  SprHandlingTimes: SprHandlingTime[];
}

export const removeHandlingTimesForSubTypes = (odc: Odc) => {
  return odc.Type === OdcType.ODC
    ? odc
    : {
        ...odc,
        DefaultInboundHandlingTime: undefined,
        ReturnHandlingTime: undefined,
        CountryHandlingTimes: undefined,
        SupplierHandlingTimes: undefined,
        SprHandlingTimes: undefined,
      };
};

export const mapFromApiToOdc = (odc: Odc): Odc => {
  return odc.Type === OdcType.ODC
    ? odc
    : { ...odc, DefaultInboundHandlingTime: "00:00", ReturnHandlingTime: "00:00" };
};
